import React from "react";
import BaseMenu from "./BaseMenu";
import MenuItem from "../../comman/MenuItem";
import { NavLink } from "react-router-dom";

const SafetyManagementMenu = (props) => {
  return (
    <BaseMenu {...props}>
      {({ checkMenuPermission, isEffectivelyExpanded, isSelected, handleClick, handleLinkClick, activeMenuPath }) => (
        <>
          {checkMenuPermission("m_1") && (
            <React.Fragment>
              <li className="nav-item d-flex justify-content-between align-items-center">
                <h6 className="premium-sidebar-heading w-100 mb-0">
                  <i className="fa fa-cogs mr-2"></i> {isEffectivelyExpanded ? "System Admin" : null}
                </h6>
              </li>
              {checkMenuPermission("sm_1_1") && (
                <MenuItem
                  isSelected={isSelected === "setupUser"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="setupUser"
                  menuTitle="Authorized Users"
                  imageName="fa fa-user"
                  headingVisible={true}
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/WorkflowUser",
                      name: "Main Users",
                      icon: "fa-user-circle-o",
                      isChecked: checkMenuPermission("ssm_1_1_1"),
                    },
                  ]}
                ></MenuItem>
              )}
              {checkMenuPermission("sm_2_1") && (
                <MenuItem
                  isSelected={isSelected === "mngPartner"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="mngPartner"
                  menuTitle="Manage Entities"
                  imageName="fa fa-building"
                  headingVisible={true}
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/ListSubcontractor/partner",
                      name: "Subcontractors",
                      icon: "fa-handshake-o",
                      isChecked: checkMenuPermission("ssm_1_2_1"),
                    },
                    {
                      url: "/Recruiter/partner",
                      name: "Recruiters",
                      icon: "fa-users",
                      isChecked: checkMenuPermission("ssm_2_2_1"),
                    },
                    {
                      url: "/ListCondidate/partner",
                      name: "Candidates",
                      icon: "fa-graduation-cap",
                      isChecked: checkMenuPermission("ssm_3_2_1"),
                    },
                  ]}
                ></MenuItem>
              )}
            </React.Fragment>
          )}
          {checkMenuPermission("m_2") && (
            <>
              <li className="nav-item">
                <h6 className="premium-sidebar-heading w-100 mb-0">
                  <i className="fa fa-file-text mr-2"></i> {isEffectivelyExpanded ? "Onboarding" : null}
                </h6>
              </li>
              <div className="collapse show">
                <ul className="nav nav-sm flex-column">
                  {checkMenuPermission("sm_1_2") && (
                    <li className="nav-item hover-effect">
                      <NavLink
                        to="/ListSubcontractor/application"
                        className={({ isActive }) =>
                          `nav-link${isActive || activeMenuPath === "/ListSubcontractor/application" ? " active" : ""}`
                        }
                        style={{ paddingLeft: "10px" }}
                        onClick={() => handleLinkClick(false)}
                      >
                        <i className="fa fa-handshake-o" aria-hidden="true" style={{ minWidth: "1.2rem", color: "#94a3b8" }}></i>
                        <span className="nav-link-text">Subcontractors</span>
                      </NavLink>
                    </li>
                  )}
                  {checkMenuPermission("sm_2_2") && (
                    <li className="nav-item hover-effect">
                      <NavLink
                        to="/Recruiter/application"
                        className={({ isActive }) =>
                          `nav-link${isActive || activeMenuPath === "/Recruiter/application" ? " active" : ""}`
                        }
                        style={{ paddingLeft: "10px" }}
                        onClick={() => handleLinkClick(false)}
                      >
                        <i className="fa fa-users" aria-hidden="true" style={{ minWidth: "1.2rem" }}></i>
                        <span className="nav-link-text">Recruiters</span>
                      </NavLink>
                    </li>
                  )}
                  {checkMenuPermission("sm_3_2") && (
                    <li className="nav-item hover-effect">
                      <NavLink
                        to="/ListCondidate/application"
                        className={({ isActive }) =>
                          `nav-link${isActive || activeMenuPath === "/ListCondidate/application" ? " active" : ""}`
                        }
                        style={{ paddingLeft: "10px" }}
                        onClick={() => handleLinkClick(false)}
                      >
                        <i className="fa fa-graduation-cap" aria-hidden="true" style={{ minWidth: "1.2rem" }}></i>
                        <span className="nav-link-text">Candidates</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </>
          )}
          {checkMenuPermission("m_3") && (
            <>
              <li className="nav-item">
                <h6 className="premium-sidebar-heading w-100 mb-0">
                  <i className="fa fa-money mr-2"></i> {isEffectivelyExpanded ? "Invoices" : null}
                </h6>
              </li>
              {checkMenuPermission("sm_1_3") && (
                <MenuItem
                  isSelected={isSelected === "projectRpt"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="projectRpt"
                  menuTitle="Invoices"
                  imageName="fa fa-filter"
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/ListCondidate/timelog",
                      name: "Time Logs",
                      icon: "fa-clock-o",
                      isChecked: checkMenuPermission("ssm_1_1_3"),
                    },
                    {
                      url: "/ListCondidate/invoice",
                      name: "Invoices & Payments",
                      icon: "fa-money",
                      isChecked: checkMenuPermission("ssm_2_2_3"),
                    },
                  ]}
                ></MenuItem>
              )}
            </>
          )}
          {checkMenuPermission("m_4") && (
            <>
              <li className="nav-item">
                <h6 className="premium-sidebar-heading w-100 mb-0">
                  <i className="fa fa-bar-chart mr-2"></i> {isEffectivelyExpanded ? "Analytics" : null}
                </h6>
              </li>
              {checkMenuPermission("sm_1_4") && (
                <MenuItem
                  isSelected={isSelected === "report"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="report"
                  menuTitle="Reports"
                  imageName="fa fa-database"
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/Dashboard",
                      name: "Dashboard",
                      icon: "fa-tachometer",
                      isChecked: checkMenuPermission("ssm_1_1_4"),
                    },
                    {
                      url: "/ApplicationReport",
                      name: "Entity Data",
                      icon: "fa-database",
                      isChecked: checkMenuPermission("ssm_2_2_4"),
                    },
                    {
                      url: "/CustomReport/report",
                      name: "Business Reports",
                      icon: "fa-bar-chart",
                      isChecked: checkMenuPermission("ssm_3_3_4"),
                    },
                    {
                      url: "/CustomReport/compliance",
                      name: "Compliance Reports/Docs",
                      icon: "fa-check-square-o",
                      isChecked: checkMenuPermission("ssm_5_5_4"),
                    },
                  ]}
                />
              )}
            </>
          )}
          {checkMenuPermission("m_5") && (
            <>
              <li className="nav-item">
                <h6 className="premium-sidebar-heading w-100 mb-0">
                  <i className="fa fa-shield mr-2"></i> {isEffectivelyExpanded ? "Security" : null}
                </h6>
              </li>
              {checkMenuPermission("sm_1_5") && (
                <MenuItem
                  isSelected={isSelected === "monitoringLogs"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="monitoringLogs"
                  menuTitle="Security"
                  imageName="fa fa-clipboard"
                  headingVisible={false}
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/MonitoringLogs",
                      name: "Monitoring Logs",
                      icon: "fa-shield",
                      isChecked: checkMenuPermission("ssm_1_1_5"),
                    },
                  ]}
                ></MenuItem>
              )}
            </>
          )}
          {checkMenuPermission("m_6") && (
            <>
              <li className="nav-item">
                <h6 className="premium-sidebar-heading w-100 mb-0">
                  <i className="fa fa-comments mr-2"></i> {isEffectivelyExpanded ? "Communications" : null}
                </h6>
              </li>
              {checkMenuPermission("sm_1_6") && (
                <MenuItem
                  isSelected={isSelected === "emailSetup"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="emailSetup"
                  menuTitle="Emails"
                  imageName="fa fa-envelope"
                  headingVisible={true}
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/PartnerEmails/mail",
                      name: "Subcontractors",
                      icon: "fa-envelope-o",
                      isChecked: checkMenuPermission("ssm_1_1_6"),
                    },
                    {
                      url: "/AgencyEmails/mail",
                      name: "Recruiters",
                      icon: "fa-envelope-open-o",
                      isChecked: checkMenuPermission("ssm_2_1_6"),
                    },
                    {
                      url: "/ApplicantEmails/mail",
                      name: "Candidates",
                      icon: "fa-envelope",
                      isChecked: checkMenuPermission("ssm_3_1_6"),
                    },
                  ]}
                ></MenuItem>
              )}
              {checkMenuPermission("sm_2_6") && (
                <MenuItem
                  isSelected={isSelected === "textSetup"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="textSetup"
                  menuTitle="Text Messages"
                  imageName="fa fa-commenting"
                  headingVisible={true}
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/PartnerEmails/text",
                      name: "Subcontractors",
                      icon: "fa-mobile",
                      isChecked: checkMenuPermission("ssm_1_2_6"),
                    },
                    {
                      url: "/AgencyEmails/text",
                      name: "Recruiters",
                      icon: "fa-comment-o",
                      isChecked: checkMenuPermission("ssm_2_2_6"),
                    },
                    {
                      url: "/ApplicantEmails/text",
                      name: "Candidates",
                      icon: "fa-comments-o",
                      isChecked: checkMenuPermission("ssm_3_2_6"),
                    },
                  ]}
                ></MenuItem>
              )}
              {checkMenuPermission("sm_3_6") && (
                <MenuItem
                  isSelected={isSelected === "surveySetup"}
                  handleClick={handleClick}
                  handleNavLinkClick={handleLinkClick}
                  menuId="surveySetup"
                  menuTitle="Surveys"
                  imageName="fa fa-list-alt"
                  headingVisible={true}
                  activeMenuPath={activeMenuPath}
                  subMenus={[
                    {
                      url: "/SurveyFeedback",
                      name: "Surveys",
                      icon: "fa-commenting-o",
                      isChecked: checkMenuPermission("ssm_1_3_6"),
                    },
                  ]}
                ></MenuItem>
              )}
            </>
          )}
        </>
      )}
    </BaseMenu>
  );
};

export default SafetyManagementMenu;
